import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import Scheduler from "./demo/scheduler";
import { AiFillPrinter } from "react-icons/ai";
import JsonDownload from "../../components/DownloadExcel/DownloadExcel";
import { AiOutlineReload } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import RotaScheduler from "./ScheduerCareFacility/scheduler";
import { getAccessList, handleDataPrint } from "../../utils/CommonFunctions";
import DataGridTable from "../../utils/DataGridTable";
import { filterData } from "../../utils/TableSearchFilter";
import NoAccessMsg from "../../components/NoAccessMsg";
import { getSettingList } from "../../redux-toolkit/reducer/adminSettings";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { setSocketCount } from "../../redux-toolkit/reducer/caresiteDataReducer";
// import { createAccessEvent } from '../../redux-toolkit/reducer/eventLogsReducer';

export default function RotaRoutes(props) {
  const { searchText, rowData } = props;

  const { topicId } = useParams();

  const { settingData } = useSelector((state) => state.adminPanelSetting);
  const { accessRoles, currentCareSiteData, socketReloadCount } = useSelector(
    (state) => state.caresiteDataReducer
  );
  const moduleAccess = useMemo(() => {
    const findCurrentModule = accessRoles?.find(
      (item) => item.moduleName === "Scheduler"
    );
    const accesssList = getAccessList(findCurrentModule?.children);
    return accesssList;
  }, [accessRoles]);

  const dispatch = useDispatch();
  // useEffect(() => {
  //   // create access event log
  //   const logData = {
  //     documentType: `rota`,
  //     description: `Rota page visited`,
  //     // documentId: careteamId,
  //   };
  //   dispatch(createAccessEvent(logData));
  // }, [topicId]);

  useEffect(async () => {
    dispatch(getSettingList(currentCareSiteId));
  }, []);


  const dowloadData = rowData?.map((item) => {
    return {
      clientName: item.clientName,
      RiskProfile: item.RiskProfile,
      Task: item.Task,
      careteamName: item.careteamName,  
      date: item.date,
      shiftPeriod: item.shiftPeriod,
      taskTime: item.taskTime,
      timeDone: item.timeDone,
      taskStatus: item.taskStatus,
      "Description / Observations": item.description,
      "Recorded Values": item.observations,
      checkoutByPerson: item?.checkoutByPerson,
    };
  });

  const columns = [
    { field: "clientName", headerName: "Name", flex: 1, minWidth: 150 },
    {
      field: "RiskProfile",
      headerName: "Risk Profile",
      minWidth: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (fieldData) => <RiskProfileBtn fieldData={fieldData} />,
    },
    {
      field: "TaskType",
      headerName: "Task Type",
      minWidth: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (fieldData) => <TaskTypeImg fieldData={fieldData} />,
    },
    { field: "Task", headerName: "Task", flex: 1, minWidth: 120 },
    { field: "careteamName", headerName: "Care Team", flex: 1, minWidth: 120 },
    { field: "date", headerName: "Date", flex: 1, minWidth: 120 },
    {
      field: "shiftPeriod",
      headerName: "Shift Period",
      flex: 1,
      minWidth: 120,
    },
    { field: "taskTime", headerName: "Task Time", minWidth: 110 },
    { field: "timeDone", headerName: "Time Done", minWidth: 90 },
    {
      field: "taskStatus",
      headerName: "Status",
      minWidth: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (fieldData) => <StatusBtn fieldData={fieldData} />,
    },
    {
      field: "description",
      headerName: "Description / Observations",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "observations",
      headerName: "Recorded Values",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "checkoutByPerson",
      headerName: "Checkout By Person",
      flex: 1,
      minWidth: 120,
    },
  ];

  const filteredData = filterData(
    columns?.map((item) => ({
      id: item.field,
      label: item.headerName,
    })),
    rowData,
    searchText
  );

  const subsriptionStatus = useMemo(() => {
    return settingData?.careHomeId?.subscriptionStatus;
  }, [settingData]);

  return (
    <>
      {topicId === "schedule" && (
        <>
          {moduleAccess?.Scheduler === "full" ||
          moduleAccess?.Scheduler === "view" ? (
            <div className="mt-2">
              {currentCareSiteData?.carefacility === "facalities" && (
                <RotaScheduler
                  SchedulerAccess={moduleAccess?.Scheduler}
                  text={searchText}
                  siteTimeZone={settingData?.timeZone}
                  reloadData={socketReloadCount}
                  subsriptionStatus={subsriptionStatus}
                />
              )}
              {currentCareSiteData?.carefacility === "agency" && (
                <Scheduler
                  SchedulerAccess={moduleAccess?.Scheduler}
                  text={searchText}
                  siteTimeZone={settingData?.timeZone}
                  reloadData={socketReloadCount}
                  subsriptionStatus={subsriptionStatus}
                />
              )}
            </div>
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "task-status" && (
        <>
          {moduleAccess?.["Task Status"] === "full" ||
          moduleAccess?.["Task Status"] === "view" ? (
            <div
              className="ag-theme-alpine cts_datatable"
              style={{ height: "100%", paddingTop: 10 }}
            >
              <div className="col-md-2 ps-0 ps-md-3">
                <AiFillPrinter
                  className="me-3 ms-1 curser_point"
                  onClick={() => handleDataPrint(dowloadData)}
                />
                <a className="curser_point me-3">
                  <JsonDownload
                    fileName="shifttasks-excel"
                    downloadfile={dowloadData}
                  />
                </a>
                <AiOutlineReload
                  className="curser_point"
                  onClick={() => dispatch(setSocketCount(1))}
                />
              </div>
              <DataGridTable
                columns={columns}
                tableHeight="calc(100vh - 190px)"
                rows={filteredData}
                handleRowSelection={() => {}}
              />
            </div>
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
    </>
  );
}

const TaskTypeImg = (props) => {
  let { fieldData } = props;
  let taskTypeImg = fieldData?.row?.TaskType;
  return (
    <img
      alt=""
      // className="profile_img_table"
      src={taskTypeImg}
    />
  );
};

const StatusBtn = (props) => {
  let { fieldData } = props;
  return (
    <button
      className="btn btn-sm table_btn"
      style={{ backgroundColor: fieldData?.row?.bgColor }}
    >
      {fieldData?.row?.taskStatus}
    </button>
  );
};
const RiskProfileBtn = (props) => {
  let { fieldData } = props;
  let riskImgObj = riskArray.find(
    (item) => item.risk === fieldData?.row?.RiskProfile?.toLowerCase()
  );
  return <>{riskImgObj ? <img src={riskImgObj.img} /> : <span>-</span>}</>;
};

const riskArray = [
  { risk: "high", img: "/admin/images/HR.svg" },
  { risk: "medium", img: "/admin/images/MR.svg" },
  { risk: "low", img: "/admin/images/LR.svg" },
];
